import hex2rgb from './hex2rgb';

const isColorBright = ([r, g, b]: string[]) => {
  const threshold = 169;
  if (+r === 243 && +g === 122 && +b === 31) return true; // #F37A1F
  return +r * 0.299 + +g * 0.587 + +b * 0.114 > threshold;
};

const getContrastingColor = function (colors: string[] | string) {
  const color = Array.isArray(colors) ? colors[5] : colors;
  const dark = '#000';
  const light = '#fff';
  const rgbColor = hex2rgb(color);
  return isColorBright(rgbColor.split(',')) ? dark : light;
};

export default getContrastingColor;
